import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Architecture extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Architecture </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                     Right from design mockups to walk-through, VR allows the architect to project 
                     his Building Information Module to the real estate developers in the most 
                     effective manner. Even if we look beyond marketing the project well, an 
                     architect can get a lot of assistance from Virtual Reality. He can get valuable 
                     feedback on the look, functionality, and overall experience. This can be integrated 
                     into the final design deliverable for demonstrating a superior quality workmanship.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Additionally, showcasing the design rendering and 3D models to 
                      multiple decision-makers becomes an efficient process. VR assists 
                      the architect to communicate an idea with impressive visual aid 
                      with the decision makers.
                      <br></br>
                      Virtual reality and augmented reality are quickly expanding into the AEC world.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      The conversation might seem a little bit like old news. AR/VR technology 
                      has been around for some time and has been a clear favorite of the media 
                      for most of it. But for any who have paid closer attention to the conversation, 
                      the stakes for the AEC industry have changed pretty dramatically since the 
                      technology was brand new.
                      <br></br> 
                      While major technology breakthroughs (often hardware) are covered by the media, 
                      we don’t always hear about the incremental shifts and improvements that are regularly 
                      taking place, especially in the software realm.
                      What’s more, most would agree that the AEC industry is at least a year or 
                      two (if not more) behind the entertainment industry in finding meaningful ways to 
                      leverage AR/VR technology for the greatest impact. Part of the difficulty is the 
                      continuous innovation that keeps improving these tools often discourages early 
                      adoption by budget-limited firms.
                      <br></br>
                      That being said, if you take a look at AR/VR tools for the AEC industry today, 
                      it would seem that we are turning a corner for widespread viability and adoption. 
                      Both software and hardware tools for AR/VR are better performing, cheaper, and more 
                      accessible than ever, and if you lost interest in the initial wave of popularity, it 
                      may be worth your while to check back in on where AR/VR is in the AEC industry today. 
                      You might just be surprised.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Architecture templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Architecture;



// WEBPACK FOOTER //
// ./src/views/Pages/Architecture/Architecture.js